import React from "react";
import { makeStyles, Button } from "@fluentui/react-components";
import type { ButtonProps } from "@fluentui/react-components";

type ASCButtonProps = {
  style?: React.CSSProperties;
  label?: any;
  onClick?: () => void;
  [dataAttr: `data-${string}`]: string | undefined;
};
const useStyles = makeStyles({
  root: { color: "red" },
});

const ASCButton = (props: ButtonProps & ASCButtonProps) => {
  const classes = useStyles();
  const dataProps = Object.keys(props).reduce((acc: any, key: any) => {
    if (key.startsWith("data-")) {
      acc[key] = props[key];
    }
    return acc;
  }, {} as Record<string, string>);
  return (
    <Button
      shape={props.shape ? props.shape : "square"}
      appearance={props.appearance ? props.appearance : undefined}
      className={props.className ? props.className : ""}
      onClick={props.onClick ? props.onClick : undefined}
      disabled={props.disabled ? props.disabled : undefined}
      size={props.size ? props.size : "medium"}
      icon={props.icon ? props.icon : undefined}
      iconPosition={props.iconPosition ? props.iconPosition : undefined}
      style={{
        ...props.style,
        minWidth: "min-content", // Ensures button shrinks to content size
      }}
      {...dataProps}
    >
      {props.label ? props.label : ""}
    </Button>
  );
};

export default ASCButton;
